
import actions from "./actions"
import mutations from "./mutations"

export default  {
    namespaced: true,

    state: () => ({ 
        layout: 'app',
        isShowAddOrUpdateModal: false,
        shiftsList: [ 
            {name: "Day Shift", start_from: "11:00", end_at: "08:00", description: "here we go"},
            {name: "Night Shift", start_from: "09:00", end_at: "06:00", description: "here you go"},
            {name: "Mid Day Shift", start_from: "02:00", end_at: "10:00", description: "here they go"},
         ],
        tableColumns: ['name', 'start_from', 'end_at','description', 'action'],
     }),

    mutations: mutations,
    actions: actions,
    getters: { 
        isShowModal(state) {
            return state.isShowAddOrUpdateModal;
        },
     }
  }
